import { Button, Result } from 'antd';
import { ROUTES } from './common/constants';
import { LABEL_TEXT } from './common/labelTexts';
import useRouter from './hooks/useRouter';

const Error404 = () => {
  const { navigate } = useRouter();
  return (
    <Result
      status="404"
      title="404"
      subTitle="Sorry, the page you visited does not exist."
      extra={
        <Button type="primary" onClick={() => navigate(ROUTES.MAIN)}>
          {LABEL_TEXT.BACK_HOME}
        </Button>
      }
    />
  );
};

export default Error404;
